import {
  ILoyaltyBonusOperation,
  ILoyaltyBonusOperationFormValues,
  ILoyaltyBonusOperationReasonOption,
} from './interfaces';

export const INITIAL_VALUES: ILoyaltyBonusOperationFormValues = {
  reason: null,
  amount: '',
  comment: '',
  type: ILoyaltyBonusOperationReasonOption.OperationType.Accrual,
  issue: null,
};

export const AMOUNT_LABELS = {
  [ILoyaltyBonusOperationReasonOption.OperationType.Accrual]: 'Начислить баллы',
  [ILoyaltyBonusOperationReasonOption.OperationType.ChargeOff]: 'Списать баллы',
} as const;

export type Issue = {
  id: string;
  typeText: string;
  addressText: string;
  time: string;
};

export const OPERATION_PROPS = {
  [ILoyaltyBonusOperation.Type.Accrual]: {
    amountLabel: 'Начислено',
    digit: '+',
  },
  [ILoyaltyBonusOperation.Type.ChargeOff]: {
    amountLabel: 'Списано',
    digit: '-',
  },
} as const;
